//pagination section
  document.addEventListener('DOMContentLoaded', function() {
    let sections = document.querySelectorAll(".featured-collection-pagination");
     sections.forEach(section => {
       
     
    const productSection = section.querySelector('.section-featured-pagination'); 
    const paginationbtn = section.querySelector('.pagination'); 
    const loader = section.querySelector('.loader-pagination');                                
    paginationbtn.addEventListener('click', function(event) {
     
      const btn = event.target.closest('.pagination__item-a');
      if (!btn) return; 
        
      event.preventDefault();  
   
    

      
     

      let paginationUrl = btn.getAttribute('data-href');
      let paginationshopUrl = btn.getAttribute('data-shop');

      if (!paginationUrl || !paginationshopUrl) {
        console.log('Missing data-href or data-shop attribute');
        return;
      }else{
       const oldPagination = section.querySelector('.pagination__list');
        if (oldPagination) {
          oldPagination.remove();
        }
  const oldProducts = section.querySelectorAll('.featured-pagination');
      oldProducts.forEach(product => {
        product.remove();
      });
           loader.style.display = "inline-flex";
     
         let dataurl = `${paginationshopUrl}${paginationUrl}`;
      console.log('Constructed Data URL:', dataurl);

      fetch(dataurl, {
        method: 'GET',
        headers: {
          'Content-Type': 'text/html',
        }
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        return response.text();
      })
      .then(html => {
        loader.style.display = "none";
        
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
      
        
        const newContent = doc.querySelectorAll('.featured-pagination');

        if (newContent.length === 0) {
          console.log('No new content found.');
          
        } else {
         
          newContent.forEach(item => {
            productSection.appendChild(item); 
            productSection.focus();
          });
        }

       
        const buttonpaginationdiv = doc.querySelector('.pagination__list');
        if (buttonpaginationdiv) {
          paginationbtn.appendChild(buttonpaginationdiv);  
        }
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
      }

     
    });
        });
  });
